import SegmentationTable from './SegmentationTable';

export default SegmentationTable;
